import { DesignationEnum } from "../constants/designations";

export const designationOptions = [
  {
    label: "Senior Solution Consultant",
    value: DesignationEnum.SENIOR_SOLUTION_CONSULTANT,
  },
  {
    label: "Salesforce Lead",
    value: DesignationEnum.SALESFORCE_LEAD,
  },
  {
    label: "Business Analyst",
    value: DesignationEnum.BUSINESS_ANALYST,
  },
  {
    label: "QA",
    value: DesignationEnum.QA,
  },
  {
    label: "Senior Developer",
    value: DesignationEnum.SENIOR_DEVELOPER,
  },
  {
    label: "Project Manager",
    value: DesignationEnum.PROJECT_MANAGER,
  },
  {
    label: "Lead Architect Mulesoft",
    value: DesignationEnum.LEAD_ARCHITECT_MULESOFT,
  },
  {
    label: "Solution Architect Mulesoft",
    value: DesignationEnum.SOLUTION_ARCHITECT_MULESOFT,
  },
  {
    label: "Lead Architect RPA",
    value: DesignationEnum.LEAD_ARCHITECT_RPA,
  },
  {
    label: "Solution Architect RPA",
    value: DesignationEnum.SOLUTION_ARCHITECT_RPA,
  },
  {
    label: "Lead Business Analyst",
    value: DesignationEnum.LEAD_BUSINESS_ANALYST,
  },
];
